export default __webpack_public_path__ + "static/about-banner-e096d350427a16cb9416056faa82b456.jpg";